import React from 'react'

 function About() {
    
    return (
     <div>
     
        <div class="row sestasblokas sonai text-white ">

        <div className="col-12 pav1 text-center "> <p> SUSIPAŽINKIM</p></div>
          <div className="col-12"> <hr className="text-white-50"/></div>
          <div className="col-12 pav2 text-white text-justify"> Sveiki! Esu Donatas. Turiu patirties diegiant, pritaikant ir prižiūrint Wordpress ir Prestashop turinio valdymo sistemas. Esu dalyvavęs leidybinėje, tarptautinių ir nacionalinių projektų veikloje. Daugelį metų buvau mokslo darbų žurnalo atsakingas redaktorius. Žurnalas tapo cituojamu tarptautinių duomenų bazių EBSCO ir CABI. 14 m. dirbau dėstytoju. Turiu ilgametę praktinių mokymų vedimo patirtį su VMA Moodle, AutoCad, RealTime Landscaping Architect, SERVE, MS Office programomis. <br/><br/>
         2005 m. baigiau KTU Informacinių technologijų studijų programą ir įgijau informatkos inžinerijos magistro kvalifikacinį laipsnį. <br/><br/>
          

2021 m. kėliau kvalifikaciją KITM organizuotuose Php programuotojo mokymuose ir įgijau jaunesniojo programuotojo kvalifikaciją. Mokymų metu išmokau programuoti JavaScript, naudoti Bootsrap ir React bibliotekas, Laravel karkasą. Pagilinau CSS (flex, grid maketai), HTML ir duomenų bazių (Mysql, Firebase) naudojimo žinias. Didelis ačiū mokytojai Jolitai.
          <br/><br/>
          Sukurti IT produktai:
          <ul>
            <li >Pritaikytos 8 interneto svetainės (5 Wordpress ir 3 HTML).</li>
            <li>1 el. parduotuvė (Prestashop).</li>
            <li >Sukurta mokomoji taikomoji kompiuterinė programa, skirta želdinių atrankai projektuojant sodybą.</li>
            <li >Paruošta leidybai daugiau nei 40 knygų, lankstinukų, posterių, prezentacijų, konferencijų programų ir kt.</li>
          </ul>
          </div>
        </div>
    </div>
    )
}
export default About